module.exports = __webpack_public_path__ + "img/avatar1.11933012.png";